import React from 'react';
import { TextField, CircularProgress, Alert, Box, Autocomplete } from '@mui/material';
import { useDepots } from '../hooks';
import type { Depot } from '../api/types';

interface DepotSelectProps {
  value: string[];
  onChange: (values: string[]) => void;
  label?: string;
  regionIds?: string[];
}

export const DepotSelect: React.FC<DepotSelectProps> = ({ value, onChange, label = 'Select Depots', regionIds }) => {
  const { data, isLoading, error } = useDepots({ regionIds });

  if (error) {
    return <Alert severity='error'>Failed to load depots. Please try again.</Alert>;
  }

  const options = data?.data || [];
  const selectedDepots = options.filter((d) => value.includes(d.id));

  const handleChange = (_event: unknown, newValue: Depot[]) => {
    onChange(newValue.map((d) => d.id));
  };

  return (
    <Box>
      <Autocomplete
        multiple
        fullWidth
        options={options}
        value={selectedDepots}
        onChange={handleChange}
        getOptionLabel={(option) => option.name}
        loading={isLoading}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder='Search depots...'
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isLoading ? <CircularProgress color='inherit' size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
            }}
          />
        )}
      />
    </Box>
  );
};
